import { render } from "./Piping.vue?vue&type=template&id=62c70253"
import script from "./Piping.vue?vue&type=script&lang=js"
export * from "./Piping.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\coreme\\suporte\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__